import { Chip } from '@mui/material';
import { WorkFlowStatus } from 'gql/index';
import { useIntl } from 'react-intl';
import { WorkflowStatusType, WorkflowStatusTypeColor } from '../types';

export const WorkflowStatusChip = (props: { workFlowStatus: WorkFlowStatus }) => {
  const { formatMessage } = useIntl();
  return <Chip label={formatMessage(WorkflowStatusType[props.workFlowStatus])} color={WorkflowStatusTypeColor[props.workFlowStatus]} size='small' />;
};